export function isPhoneNumber(value: string) {
  /**
   * REGEX source:
   * https://stackoverflow.com/a/29767609
   */
  const phoneNumberValidate = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
  return !!phoneNumberValidate.test(String(value).toLowerCase());
}
